import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MembershipStatus } from '../../../../models/membership.status';

@Component({
  selector: 'app-btn-member-status',
  standalone: true,
  templateUrl: './btn-member-status.component.html',
  styleUrls: ['./btn-member-status.component.css'],
})
export class BtnMemberStatusComponent {
  @Input() status: MembershipStatus | undefined = MembershipStatus.unknown;
  @Input() isDisabled: boolean = false;

  @Output() onClick: EventEmitter<MembershipStatus> = new EventEmitter();

  membershipStatus = MembershipStatus;

  constructor() {}
}
